// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"GreyBox__wrapper___33Nwk","isSmallMargin":"GreyBox__isSmallMargin___2d-xy","greybox":"GreyBox__greybox___3770U","outerMargin":"GreyBox__outerMargin___1LW2w","col2":"GreyBox__col2___1zjdu","fullWidth":"GreyBox__fullWidth___1VoCn","isCenter":"GreyBox__isCenter___35eXV","noPrint":"GreyBox__noPrint___iWaHu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/GreyBox/GreyBox.scss
// module id = 654
// module chunks = 0